<template>
  <section>
    <b-button v-b-modal="`query-builder-modal-${uid}`">
      QueryBuilder
    </b-button>
    <b-modal
      :id="`query-builder-modal-${uid}`"
      title="Constructor de consultas"
      centered
      size="xl"
      @ok="onSave"
      @cancel="onCancel"
    >
      <div class="scroll py-4 mb-4">
        <GroupNodes
          :nodes="query"
          :settings="settings"
          @node-add="onNodeAdd"
          @group-add="onGroupAdd"
          @node-remove="onNodeRemove"
          @group-remove="onGroupRemove"
        />
      </div>
      <code>
        {{ build }}
      </code>
      <hr class="w-100">
      <span v-for="(error, index) of validation" :key="index" class="d-block text-danger">
        {{ error }}
      </span>
    </b-modal>
  </section>
</template>

<script>
// Components
import GroupNodes from '@/components/lmQueryBuilder/components/GroupNodes.vue'

export default {
  name: 'LmQueryBuilder',
  components: {
    GroupNodes
  },
  props: {
    settings: Array
  },
  data () {
    return {
      uid: this._uid,
      query: []
    }
  },
  computed: {
    build () {
      return this.generateQuery(this.query)
    },
    validation () {
      return this.generateErrors(this.query)
    }
  },
  methods: {
    generateErrors (data, prevErrors = []) {
      let errors = []
      errors = errors.concat(prevErrors)

      data.forEach((el, index) => {
        el.error = false
        el.errorMessage = null

        if (index === data.length - 1 && el?.type === 'operator') {
          errors.push('El ultimo elemento de un grupo no puede ser un operador.')
          el.error = true
          el.errorMessage = 'El ultimo elemento de un grupo no puede ser un operador.'
        }
        if (index === 0 && el?.type === 'operator') {
          errors.push('El primer elemento de un grupo no puede ser un operador.')
          el.error = true
          el.errorMessage = 'El primer elemento de un grupo no puede ser un operador.'
        }
        if (el?.type === 'expression' && data.at(index - 1)?.type !== 'operator' && index > 0) {
          errors.push('Las expresiones deben ser unidas por operadores')
          el.error = true
          el.errorMessage = 'Las expresiones deben ser unidas por operadores.'
        }

        if (el?.children && el?.children?.length) {
          const group = this.generateErrors(el.children, errors)
          errors = errors.concat(group)
        }
      })
      return errors
    },
    generateQuery (data) {
      let build = ''
      data.forEach((el, index) => {
        if (el?.type === 'expression') {
          build += ` ${el.property} ${el.validation} ${el.value} `
        }
        if (el?.type === 'operator') {
          build += ` ${el.value} `
        }
        if (el?.children && el?.children?.length) {
          const group = this.generateQuery(el.children)
          build += `${group}`
        }
      })
      return `(${build})`
    },
    onNodeAdd (event) {
      if (event.newNode.type === 'expression') {
        event.nodes.push(event.newNode)
      }
      if (event.newNode.type === 'operator') {
        event.nodes.push(event.newNode)
      }
    },
    onNodeRemove (event) {
      const index = event.nodes.findIndex(el => el.id === event.id)
      event.nodes.splice(index, 1)
    },
    onGroupAdd (event) {
      event.nodes.push(event.newGroup)
    },
    onGroupRemove (event) {
      function filter (data, id) {
        const r = data.filter(item => {
          if (item.children) {
            item.children = filter(item.children, id)
          }
          return item.id !== id
        })
        return r
      }
      this.query = filter(this.query, event)
    },
    onSave () {
      this.$emit('input', { build: this.build, constructor: this.query })
    },
    onCancel () {
      this.query = []
    }
  }
}
</script>

<style scoped>
.scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.scroll::-webkit-scrollbar {
  height: 8px;
}

.scroll::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: #888;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
